.bottomBar {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  &.footer {
    background: var(--base-white);
    width: calc(100% + 10rem);
    margin: 0 -5rem 0 -5rem;
    padding: 1.5rem 5rem;
  }
  &.form {
    margin-top: 2.5rem;
  }
  &.inputGrid {
    background: var(--base-white);
    width: 100%;
    margin-top: 2.5rem;
    padding: 1.5rem 6.5rem;
    border-radius: 1rem;
  }
  > section {
    display: flex;
    align-items: center;
    gap: 2rem;
    &:has(button) {
      min-height: 4rem;
    }

    &:global(.hidden) {
      display: none;
      visibility: hidden;
      opacity: 0;
    }
  }
}
